import React from "react";
import styled from "styled-components";
import { Spinner } from "baseui/spinner";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Loading = () => {
  return (
    <Container key="spinner">
      <Spinner key="spinnnnn" />
    </Container>
  );
};
export default Loading;
